module.exports = __webpack_public_path__ + "img/package_coolfan.804cf357.svg";